module.exports = __webpack_public_path__ + "assets/contorni.4e8fa91d.svg";